import { useTranslation } from "react-i18next";

const LANGS = [
  { id: "es", label: "ES", flag: "https://flagcdn.com/es.svg" },
  { id: "en", label: "EN", flag: "https://flagcdn.com/gb.svg" },
];

export default function LanguageSwitcher({ className = "" }) {
  const { i18n } = useTranslation();
  const current = (i18n.resolvedLanguage || i18n.language || "es").slice(0, 2);
  return (
    <div className={`inline-flex items-center gap-1 rounded-full border border-slate-200 bg-white p-0.5 ${className}`} data-testid="language-switcher">
      {LANGS.map((l) => (
        <button
          key={l.id}
          type="button"
          data-testid={`lang-switch-${l.id}`}
          onClick={() => i18n.changeLanguage(l.id)}
          className={`flex items-center gap-1.5 rounded-full px-2.5 py-1 text-sm font-semibold transition-colors ${
            current === l.id ? "bg-slate-800 text-white" : "text-slate-600 hover:bg-slate-100"
          }`}
        >
          <img src={l.flag} alt="" className="w-4 h-auto rounded-sm" /> {l.label}
        </button>
      ))}
    </div>
  );
}
